/**
 * Message Type that can be sent to a ChargePoint
 */
export enum AvailabilityType {
    INOPERATIVE = 'INOPERATIVE',
    OPERATIVE = 'OPERATIVE'
}
